import { useEffect, useRef, useState } from 'react';
import { FaRedoAlt, FaTimes } from 'react-icons/fa';
import classes from './service-worker-update-toast.module.css';

const ServiceWorkerUpdateToast: React.FC = () => {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const shouldReloadRef = useRef(false);

  useEffect(() => {
    const handleUpdate = (event: WindowEventMap['kokki-service-worker-update']) => {
      setRegistration(event.detail);
    };

    const handleControllerChange = () => {
      if (!shouldReloadRef.current) return;
      shouldReloadRef.current = false;
      window.location.reload();
    };

    window.addEventListener('kokki-service-worker-update', handleUpdate);
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    }

    return () => {
      window.removeEventListener('kokki-service-worker-update', handleUpdate);
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      }
    };
  }, []);

  const handleRefresh = () => {
    setIsRefreshing(true);
    shouldReloadRef.current = true;

    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      return;
    }

    window.location.reload();
  };

  if (!registration) return null;

  return (
    <div className={classes.toast} role="alert" aria-live="polite">
      <div className={classes.copy}>
        <strong>New Kokki update ready</strong>
        <span>Refresh to use the latest version.</span>
      </div>

      <button
        className={classes.refreshButton}
        type="button"
        onClick={handleRefresh}
        disabled={isRefreshing}
      >
        <FaRedoAlt aria-hidden="true" />
        <span>{isRefreshing ? 'Refreshing' : 'Refresh'}</span>
      </button>

      <button
        className={classes.closeButton}
        type="button"
        onClick={() => setRegistration(null)}
        aria-label="Dismiss update notice"
      >
        <FaTimes aria-hidden="true" />
      </button>
    </div>
  );
};

export default ServiceWorkerUpdateToast;
